import { render } from "./ProjectsListView.vue?vue&type=template&id=2cb0045e"
import script from "./ProjectsListView.vue?vue&type=script&lang=js"
export * from "./ProjectsListView.vue?vue&type=script&lang=js"

import "./ProjectsListView.vue?vue&type=style&index=0&id=2cb0045e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__